<template>
    <v-card class="mt-6 shop-product-supplies">
        <v-card-title>
            <v-row>
                <v-col class="subtitle-1 py-0">
                    도서산간설정 (사용/미사용)<span v-if="isOrderShipping" class="ml-2 subtitle-2" style="color:grey">※ 주문별배송 선택 시 운영정보설정의 도서산간설정 사용</span>
                </v-col>
                <v-col md="auto" sm="auto" class="py-0">
                    <v-switch v-model="form.islandEnabled" dense hide-details class="mt-0" @change="input" :disabled="isOrderShipping"></v-switch>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text v-if="form.islandEnabled">
            <v-row v-for="(island, index) in form.island.groups" :key="index">
                <v-col cols="12">
                    <v-text-field v-model="island.price" @change="input" :disabled="isOrderShipping" :label="`'${island.name}' 지역 추가배송비`" placeholder=" " dense hide-details></v-text-field>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import api from "@/api";

export default {
    props: {
        value: { type: Object, default: null },
    },
    data: () => {
        return {
            form: {
                islandEnabled: false,
                island: { groups: [] },
            },
            policy: {
                islandEnabled: false,
                island: { groups: [] },
            },
        };
    },
    computed: {
        _store() {
            return this.value?._store || this.$store.state.payload._user;
        },
        isOrderShipping() {
            return this.value?.shipping?.code == "order";
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                await this.getIslands();
                this.setWithPolicy();
                if (!this.isOrderShipping && this.value?._id) this.setWithValue();
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },
        getIslands() {
            return new Promise(async (resolve, reject) => {
                const { _store } = this;
                try {
                    var { islands: groups } = await api.console.shop.islands.getIslands({ params: { _store } });

                    this.policy.islandEnabled = groups.reduce((isEnabled, { enabled }) => (isEnabled ? true : enabled), undefined);
                    this.policy.island.groups = groups.map(({ name, code, price }) => ({ name, code, price }));

                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        },
        setWithPolicy() {
            this.form = JSON.parse(JSON.stringify(this.policy));
        },
        setWithValue() {
            this.form.islandEnabled = this.value.islandEnabled;

            this.form.island.groups = this.form.island.groups.map((island) => {
                let price = this.getPrice(this.value.island.groups, island);
                if (price == undefined) price = this.getPrice(this.policy.island.groups, island) || 0;

                return { ...island, price };
            });
        },
        getPrice(islands, island) {
            return islands.find(({ code }) => island.code == code)?.price;
        },
        input() {
            this.$set(this.value, "islandEnabled", this.form.islandEnabled);
            this.$set(this.value, "island", this.form.island);

            this.$emit("input", this.value);
        },
    },
    watch: {
        async isOrderShipping() {
            if (this.isOrderShipping) {
                this.setWithPolicy();
            } else {
                this.setWithValue();
                this.input();
            }
        },
    },
};
</script>
